import { inject } from 'mobx-react';
import { LoadingComponent } from './component';
export const Loading = inject(({ ui }) => ({
    loading: ui.loading,
}))(LoadingComponent);
//# sourceMappingURL=index.js.map